import { useContext, useEffect, useState } from "react";

import type { Day } from "date-fns";

import AppContext, { type AppContextInterface } from "~/common/AppContext";

export const convertWeekday = (user: AppContextInterface["user"]): Day => {
	const firstWeekDay = user?.internalAttributes?.firstWeekDay;

	switch (firstWeekDay) {
		case "Mon": {
			return 1 as const;
		}
		case "Sat": {
			return 6 as const;
		}
		default: {
			return 0 as const;
		}
	}
};

export default function useFirstWeekday(): Day {
	const { user } = useContext(AppContext);
	const [firstWeekday, setFirstWeekday] = useState<Day>(() => convertWeekday(user));
	useEffect(() => setFirstWeekday(convertWeekday(user)), [user]);

	return firstWeekday;
}
